import React from 'react';
import './input.style.scss';

const Input = ({ ...props }) => {
  return <input {...props} />;
};

export default Input;
